import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/** Reusable password input with show/hide toggle. */
export default function PasswordInput({ value, onChange, placeholder = 'Password', className = '', testid, autoFocus = false, required = false, name }) {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <input
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoFocus={autoFocus}
        required={required}
        name={name}
        data-testid={testid}
        className="w-full rounded-lg border border-border bg-background pl-3 pr-10 py-2 text-sm"
      />
      <button
        type="button"
        onClick={() => setShow(s => !s)}
        title={show ? 'Esconder password' : 'Mostrar password'}
        data-testid={testid ? `${testid}-toggle` : undefined}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-muted-foreground hover:text-foreground transition-colors"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
